<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconLock_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M7 6.56v-.725C7 3.166 9.24 1 12 1s5 2.166 5 4.835v3.627h2c.552 0 1 .433 1 .967v11.604c0 .534-.448.967-1 .967H5c-.552 0-1-.433-1-.967V10.429c0-.534.448-.967 1-.967h2V6.56m8 2.902V5.835c0-1.653-1.29-2.998-3-2.998S9 4.182 9 5.835v3.627z"
        clip-rule="evenodd"
    />
</svg>
